<template>
  <div class="search">
    <v-text-field
      :value="value"
      single-line
      flat
      filled
      clearable
      solo
      hide-details
      class="search"
      clear-icon="close"
      label="Pesquisar..."
      append-icon="search"
      background-color="white"
      color="primary"
      @click:append="$emit('clickAppend')"
      @keydown.enter="$emit('keydownEnter')"
      @click:clear="$emit('clickClear')"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'SearchInput',

  props: {
    value: String,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';
@import '@/assets/scss/buttons.scss';
.search {
  box-shadow: 0 8px 40px rgba($color-black, 0.08);
}
</style>
